var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InfoPage',[_c('h1',{staticClass:"display-1 mt-2 mt-md-6 mt-lg-12 mb-6"},[_vm._v(_vm._s(_vm.$t("erreur.collecte.titre")))]),_c('p',[_vm._v(_vm._s(_vm.$t("erreur.collecte.description")))]),_c('p',[_vm._v(_vm._s(_vm.$t("erreur.collecte.telephone")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }